import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import CTLTable from "application/components/CTLTable";
import { getColumns, Attributes, operationURLS } from "./model";
import { application } from "globals/endpoints";
import CTLBaseDialogForm from "application/components/CTLBaseDialogForm";
import DeleteConfirmation from "application/components/DeleteConfirmation";
import CTLNotification from "application/components/CTLNotification";
import { getUpdateColumns } from "./updateModel";
import { getCallCenterConfigurationsMenu } from "globals/configuration/callCenterConfigurationMenu";

function TeamLeadQueueAssosiation({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) {
  const [controller] = useMaterialUIController();
  const { activePage } = controller;
  const [advancedFilters, setAdvancedFilters] = useState([]);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [updateList, setUpdateList] = useState(Date.now());
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  const CallCenterConfigurationsMenu = getCallCenterConfigurationsMenu();
  const Attributes = {
    formSize: "md",
    enableAddButton: true,
    modes: CallCenterConfigurationsMenu.map((item) => {
      return {
        id: item.key,
        name: item.name,
        iconName: item.icon,
        url: item.url,
        description: item.description,
      };
    }),
  };
  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks &&
      registerCallBacks({
        openAdvancedFilter: onOpenFilter,
        openForm: onOpenForm,
        Single: onOpenUpdate,
      });
  }, [activePage]);

  function onOpenFilter() {
    setOpenFilter(true);
  }

  function onOpenForm() {
    setFormData(Date.now());
    setOpenForm(true);
  }

  const editRow = (row) => {
    setFormData(row);
    setOpenUpdate(true);
  };

  const deleteRow = (row) => {
    setSelectedRow(row);
    setConfirmDelete(true);
  };

  const onCancel = () => {
    setSelectedRow([]);
    setConfirmDelete(false);
  };

  const onAgree = (row) => {
    application
      .post(operationURLS.delete, {
        intId: [row.id],
      })
      .then((response) => {
        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          status: response.data.messageDetail,
          type: "success",
          pagename: pageName,
        });
      });

    setConfirmDelete(false);
  };

  function onUpdateForm(data) {
    application
      .post(operationURLS.update, data)
      .then((response) => {
        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          status: response.data.message,
          type: "success",
          pagename: pageName,
        });
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status: error.response.data.message,
          type: "error",
          pagename: pageName,
        });
      });
    setOpenUpdate(false);
  }

  function onCreateForm(data) {
    application
      .post(operationURLS.create, data)
      .then((response) => {
        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          status: response.data.messageDetail,
          type: "success",
          pagename: pageName,
        });
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status: error.response.data.messageDetail,
          type: "error",
          pagename: pageName,
        });
      });
    setOpenForm(false);
  }

  function onCloseForm() {
    setOpenForm(false);
  }

  function onOpenUpdate() {
    setFormData({
      eventTime: Date.now(),
    });
    setOpenUpdate(true);
  }

  function onCloseUpdate() {
    setOpenUpdate(false);
  }

  return (
    <MDBox>
      <DeleteConfirmation
        entityName="TeamLeadQueueAssosiation"
        data={selectedRow}
        columns={getColumns(deleteRow, editRow)}
        confirmDelete={confirmDelete}
        onAgree={onAgree}
        onCancel={onCancel}
      />
      <CTLBaseDialogForm
        entityName="TeamLeadQueueAssosiation"
        columns={getColumns()}
        openForm={openForm}
        onSaveForm={onCreateForm}
        onCloseForm={onCloseForm}
        formData={formData}
        pageAttributes={Attributes}
      />
      {onOpenUpdate && (
        <CTLBaseDialogForm
          entityName="TeamLeadQueueAssosiation"
          columns={getUpdateColumns()}
          openForm={openUpdate}
          onSaveForm={onUpdateForm}
          onCloseForm={onCloseUpdate}
          formData={formData}
          pageAttributes={Attributes}
        />
      )}
      <CTLTable
        apiURL={operationURLS.list}
        advancedFilters={advancedFilters}
        columns={getColumns(deleteRow, editRow)}
        entriesPerPage={false}
        canSearch
        defaultSortDirection="asc"
        defaultSortColumn="id"
        pageId={pageId}
        list
        searchText={searchText}
        hasRowSelection={false}
        updateList={updateList}
      />
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}

export default TeamLeadQueueAssosiation;
